import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.91 6.953 12.7 1.672a1.54 1.54 0 0 0-1.416 0L1.076 6.953a.615.615 0 0 0 0 1.094l10.209 5.281a1.54 1.54 0 0 0 1.416 0L22.91 8.047a.616.616 0 0 0 0-1.094"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m.758 12.75 10.527 5.078a1.54 1.54 0 0 0 1.416 0l10.557-5.078"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m.758 17.25 10.527 5.078a1.54 1.54 0 0 0 1.416 0l10.557-5.078"
    }, null, -1)
  ])))
}
export default { render: render }